import App from './EC_Travel_v2';

export default App;
